export const loggerHandleFunction = (log) => {
    console.log(log);
    return;
}